import SupportPane from "./SupportPane"

export default  SupportPane;



// WEBPACK FOOTER //
// ./src/components/App/SupportDashboard/SupportBody/SupportPane/index.js